import React, { useState } from "react";
import {
    CSS,
    NOTE_HEIGHT,
    NOTE_WIDTH
 } from "../../render/renderUtils";
import RydHeaderDialogBox from "../widgets/RydHeaderDialogBox";
import { TrackColor } from "../../render/trackColor";

// filepath: /home/john/Desktop/workspace/eurydice/view/app/src/components/pickers/TrackColorPicker.tsx

export interface TrackColorPickerProps {
    color?: TrackColor.Color;
    onColorSelect?: (color: string) => void;
    steps?: number;
    brightnessSteps?: number;
    minColor?: TrackColor.Color;
    maxColors?: TrackColor.Color[];
}

export function TrackColorPicker({
    color,
    onColorSelect,
    steps = TrackColor.DEFAULT_COLOR_TABLE_PARAMS.steps,
    brightnessSteps = TrackColor.DEFAULT_COLOR_TABLE_PARAMS.brightnessSteps,
    minColor = TrackColor.DEFAULT_COLOR_TABLE_PARAMS.minColor,
    maxColors = TrackColor.DEFAULT_COLOR_TABLE_PARAMS.maxColors

}: TrackColorPickerProps) {
    const [selectedColor, setSelectedColor] = useState<TrackColor.Color>(color ? color : TrackColor.DEFAULT_COLOR);
    const [collapsed, setCollapsed] = useState(true);
    const colors = TrackColor.generateColorTable(minColor, maxColors, steps, brightnessSteps).reverse();
    const defaultColor = colors[0] || CSS.VAR('--note-color');

    const handleColorClick = (color: TrackColor.Color) => {
        setSelectedColor(color);
        if (onColorSelect) {
            onColorSelect(color);
        }
    };

    if (collapsed) {
        return (
            <button onClick={() => setCollapsed(false)}
                style={{
                    backgroundColor: selectedColor || defaultColor,
                    width: `${NOTE_WIDTH}px`,
                }}>
                &nbsp;
            </button>
        );
    }

    return (
        <RydHeaderDialogBox closeCB={() => setCollapsed(true)}>
            <>
                Track color:
                <div
                    className="color-picker-grid"
                    style={{
                        display: "grid",
                        gridTemplateColumns: `repeat(${4}, 1fr)`,
                        gap: "0px",
                        overflow: 'scroll',
                        height: '120px',
                    }}
                >
                    {colors.map((color, index) => (
                        <div
                            key={index}
                            onClick={() => handleColorClick(color)}
                            style={{
                                backgroundColor: color,
                                outline: selectedColor === color ? "3px solid #000" : "1px solid #ccc",
                                cursor: "pointer",
                                height: `${NOTE_HEIGHT}px`,
                                width: '40px',
                                border: '0px',
                            }}
                            title={color}
                        />
                    ))}
                </div>
                {/* {selectedColor && (
                <p style={{ marginTop: "8px" }}>
                    Selected Color: <div style={{
                            backgroundColor: selectedColor,
                            cursor: "pointer",
                            height: "20px",
                            width: '40px'
                        }}></div>
                </p>
            )} */}
            </>
        </RydHeaderDialogBox>
    );
}